<section class="toggle-form" [ngClass]="{ active: isActionItemSliderOpen }" style="overflow-y: auto">
    <div class="formwrap">
      <p-panel header={{sliderHeaderText}}>
        <ng-template pTemplate="icons">
          <p-button appPreventDoubleClick styleClass="p-button-text" id="sliderCloseButton" type="button" label="Close" class="align-right"
            (debounceClick)="closeSlider()"></p-button>
        </ng-template>
        <form [formGroup]="actionItemForm">
          <div *ngIf="errorMessages.length > 0">
            <p-messages severity="error">
              <ng-template pTemplate>
                <span class="p-message-icon pi pi-times-circle"></span>
                <span class="p-ml-2"
                  >{{errorHeading}}</span
                >
                <ul>
                  <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
                </ul>
              </ng-template>
            </p-messages>
          </div>
          <div class="fields-row">
            <div class="field field-title field-required">
              <bpt-text-input label="Title" 
              id="title" 
              formControlName="title" 
              [required]="true"
              [ngClass]="{ 'error-highlight': mandatoryFields.title}"></bpt-text-input>
            </div>
            <div class="field field-required">
              <bpt-dropdown label="Type" 
              [options]="typeOptions" 
              [editable]="false" 
              formControlName="type" 
              id="actionItemTypes"
              [showClear]="true" 
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              [required]="true"
              [ngClass]="{ 'error-highlight': mandatoryFields.type}">
              </bpt-dropdown>
            </div>
          </div>
          <div class="fields-row">
            <div class="field">
              <bpt-text-input formControlName="description" 
              [highlightAllOnFocus]="true" [multiLine]="true"
                id="description" label="Description"></bpt-text-input>
            </div>
          </div>
          <div class="fields-row">
            <div class="field">
              <bpt-datetime
            id="dueDate"
            label="Due Date"
            formControlName="dueDate"
            [required]="true"
            [ngClass]="{ 'error-highlight': mandatoryFields.dueDate}"
          ></bpt-datetime>
            </div>
            <div class="field mt-3 ml-6">
              <p-checkbox
                p-label-active
                label="Risk Assessment Required?"
                [binary]="true"
                formControlName="isRiskAssessmentRequired"
                (ngModelChange)="1"
              >
              </p-checkbox>
              <i
                class="fa fa-info-circle ml-2 info-icon-color"
                aria-hidden="true"
                pTooltip="{{ infoForRiskAssessmentRequired }}"
              ></i>
            </div>
            <div class="field mt-3">
              <p-checkbox
                p-label-active
                label="Verification Required?"
                [binary]="true"
                formControlName="isVerificationRequired"
                (onChange)="verificationCheckboxChange()"
              >
              </p-checkbox>
              <i
                class="fa fa-info-circle ml-2 info-icon-color"
                aria-hidden="true"
                pTooltip="{{ infoForVerificationRequired }}"
              ></i>
            </div>          
          </div>
          <div class="fields-row">
            <div class="field">
              <bpt-dropdown label="Assignee(s)" 
              [options]="assigneeList" 
              [editable]="false" 
              formControlName="assignees" 
              id="assignees"
              [showClear]="true" 
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              [required]="true"
              [multiSelect]="!isEditSlider"
              [ngClass]="{ 'error-highlight': mandatoryFields.assignees}">
              </bpt-dropdown>
            </div>
            <div class="field">
              <bpt-dropdown label="Verifier" 
              [options]="verifiersList"
              [editable]="false" 
              formControlName="verifier" 
              id="verifier"
              [showClear]="true" 
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              [required]="isVerifierRequired"
              [ngClass]="{ 'error-highlight': mandatoryFields.verifier}">
              </bpt-dropdown>
            </div>
          </div>
          <div class="fields-row">
            <div class="field">
              <bpt-text-input formControlName="verificationNotes" [highlightAllOnFocus]="true" [multiLine]="true"
                id="verificationNotes" label="Verification Notes"></bpt-text-input>
            </div>
          </div>
          <div class="fields-row">
            <div class="field">
              <bpt-text-input formControlName="actionTaken" [highlightAllOnFocus]="true" [multiLine]="true"
                id="actionTaken" label="Action Taken"></bpt-text-input>
            </div>
          </div>
          <div class="fields-row">
            <div class="field">
              <bpt-file-upload
                [disabled]="false"
                [uploadFiles]="uploadSuccess"
                [deleteFile]="deleteFile"
                [fileNames]="fileNamesToSave || []"
                [fileTypes]="attachmentFileTypes"
                [maxSize]="maxFileSize"
              ></bpt-file-upload>
            </div>
          <div class="field" *ngIf="event != '' && attachmentData && attachmentData.length > 0">
              <div *ngFor="let attachment of attachmentData" class="mt-1">
                <em class="blue-color cursor-pointer" (click)="downloadAttachment(attachment.fileId, attachment.attachmentName)"
                  ><app-file-icon [fileType]="attachment.attachmentType"></app-file-icon
                ></em>
                <span class="ml-3">{{ attachment.attachmentName }}</span>
                    <em
                      class="ml-3 fa fa-trash blue-color cursor-pointer"
                      (click)="deleteAttachment(attachment.fileId)"
                    ></em>
              </div>
            </div>
          </div>
          <div class="fields-row">
            <div class="field"></div>
            <div class="field"></div>
            <div class="field"></div>
            <div class="field">
          <p-button
            appPreventDoubleClick
            label="Save"
            type="save"
            id="createActionItemSaveBtn"
            class="align-right"
            (debounceClick)="saveActionItem()"
          >
          </p-button>
        </div>
        </div>
        </form>
      </p-panel>
    </div>
  </section>

  <app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField" (confirmed)="saveAssignmentGroupwithInactiveUsers()" (dialogClosed)="closeConfirmationDailog($event)">
  </app-confirmation-dialog>